import { Grid } from '@mui/material';
import {
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarFilterButton,
} from '@mui/x-data-grid-premium';
import { EstateWorkItemStatus } from 'queries';

const TaskListCustomToolbar = ({ tabSelected }: { tabSelected: EstateWorkItemStatus }) => {
  let tabName = '';
  switch (tabSelected) {
    case EstateWorkItemStatus.AssignedReady:
      tabName = 'assigned-ready';
      break;
    case EstateWorkItemStatus.Completed:
      tabName = 'completed';
      break;
  }

  return (
    <GridToolbarContainer>
      <GridToolbarFilterButton />
      <Grid container justifyContent="flex-end">
        <GridToolbarExport
          csvOptions={{
            allColumns: true,
            fileName: `trustate-manage-tasks-${tabName}-${new Date().toISOString().slice(0, 10)}`,
            utf8WithBom: true,
          }}
        />
      </Grid>
    </GridToolbarContainer>
  );
};

export default TaskListCustomToolbar;
